import { generateObjectZeroId } from "components/CommonLib/CommonLib";
import { create } from "zustand";

// 검색 조건 베이스
const baseSearchParams = {
  reject_zero_eight_zero: false,
  agree_marketing: false,
  agree_personal: false,
  branch_info: {
    branch_id: generateObjectZeroId(),
    branch_name: "",
  },
  combo_item: {
    branch_hq_info_list: [
      {
        branch_list: [
          {
            branch_id: "",
            branch_name: "",
          },
        ],
        hq_info: {
          hq_id: "",
          hq_name: "",
        },
      },
    ],
    branch_list: [[""]],
    hq_list: [""],
  },
  hq_info: {
    hq_id: generateObjectZeroId(),
    hq_name: "",
  },
  phone: "",
  p1: "",
  p2: "",
  p3: "",
  target_name: "",
};

export const useUnsubsListStore = create((set) => ({
  // ========== State ===========
  // 수신거부 목록 리스트 검색 State
  unsubsListSearchParams: {
    ...baseSearchParams,
  },
  unsubsListPage: 1,

  unsubsListHqIdx: 0,

  // ========== Action ==========
  // 수신거부 목록 리스트 검색 조건 변경
  setSearchParams: (key, value) => {
    set((state) => ({
      unsubsListSearchParams: {
        ...state.unsubsListSearchParams,
        [key]: value,
      },
    }));
  },

  // Page 값 변경
  setPage: (value) => {
    set({ unsubsListPage: value });
  },

  // Hq Index 값 변경
  setHqIdx: (value) => {
    set({ unsubsListHqIdx: value });
  },

  // 검색 조건 리셋
  resetSearchParams: () => {
    set({
      unsubsListSearchParams: {
        ...baseSearchParams,
      },
    });
    set({ unsubsListHqIdx: 0 });
  },
}));
